import React, { useState } from "react";
import RichText from "../States/RichText";

export default function CityAccodian(props) {
  const [active, setActive] = useState(false);
  const toggleAccordion = () => {
    setActive(!active);
  };
  return (
    <div className="panel panel-default">
      <div className="panel-heading active" role="tab" id="headingFive">
        <h4 className="panel-title">
          <a
            className={active ? "" : "collapsed"}
            role="button"
            onClick={toggleAccordion}
            // data-toggle="collapse"
            //   data-parent="#accordion"
            // href="#accordion"
            //   href="#collapseOne"
            aria-expanded="false"
            aria-controls="collapseOne"
          >
            <img src={props?.item?.Icon?.filename} className="panel_icons" />
            <span>{props?.item.Term}</span>
          </a>
        </h4>
      </div>
      {active && (
        <div
          id="collapseTwo"
          className=""
          role="tabpanel"
          aria-labelledby="headingFive"
        >
          <div className="panel-body">
            <RichText Description={props?.item.Definition}></RichText>
          </div>
        </div>
      )}
    </div>
  );
}
